import type { InvoicesSummary } from '../api'

export const summariesEqual = (a: InvoicesSummary, b: InvoicesSummary): boolean =>
  a.totalAmount === b.totalAmount
  && a.invoiceCount === b.invoiceCount
  && a.paidAmount === b.paidAmount
  && a.paidCount === b.paidCount
  && a.dueAmount === b.dueAmount
  && a.dueCount === b.dueCount
